<template>
	<span
		class="relative text-sm text-functional-size-md leading-6 text-gray-900 tracking-wide"
	>
		{{ title }}
		<span
			v-if="description"
			data-testid="atom-input-util-label-description"
			class="text-gray-600 text-functional-size-sm leading-8 block my-1"
		>
			{{ description }}
		</span>
		<span
			v-if="!isRequired"
			data-testid="atom-input-util-label-optional"
			class="text-functional-size-xs text-gray-500 font-normal leading-3 absolute left-0 bottom-0 -mb-5 z-10 bg-white ml-1.5 px-1"
		>
			optioneel
		</span>
	</span>
</template>

<script setup lang="ts">
defineProps<{
	title: string;
	description?: string;
	isRequired: boolean;
}>();
</script>
